import { CREATE_SHIPPING_PLAN_GET_FAILURE, CREATE_SHIPPING_PLAN_GET_REQUEST, CREATE_SHIPPING_PLAN_GET_SUCCESS, CREATE_SHIPPING_PLAN_POST_REQUEST, CREATE_SHIPPING_PLAN_STYLE_NUMBER_SUCCESS, CREATE_USER_FORM_SHIPPING_PLAN, DELETE_SHIPPING_PLAN_FAILURE, DELETE_SHIPPING_PLAN_REQUEST, NAVIGATE_SHIPPING_PLAN, NAVIGATE_SHIPPING_PLAN_DETAILS, SHIPPING_PLAN_USERFORM_NAVIGATE_TO_DETAIL_TAB, SHIPPING_PLAN_USERFORM_RESET, UPDATE_SHIPPING_PLAN_GET_FAILURE, UPDATE_SHIPPING_PLAN_GET_REQUEST, UPDATE_SHIPPING_PLAN_GET_SUCCESS } from "./shippingPlan.actionType";

export const SHIPPING_PLAN = 'shippingPlan'

const selected = new Date(new Date());
selected.setDate(selected.getDate() + 1);

let initialState = {
    loading: false,
    isShippingPlan: false,
    userform: {
        dispatchDate: new Date(),
        fldAppointmentDate: new Date(),
        fldPickupShipmentDate: selected,
        fldDisPatchShipmentDate: new Date()
    },
    fldStartDate: new Date().setDate(new Date().getDate() - 15),
    fldEndDate: new Date(),
    fldFKUnitId: 1,
    shippingPlanGet: [],

};


export let shippingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_SHIPPING_PLAN_GET_REQUEST:
        case UPDATE_SHIPPING_PLAN_GET_REQUEST:
        case DELETE_SHIPPING_PLAN_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case CREATE_SHIPPING_PLAN_POST_REQUEST:
            return {
                ...state,
                loading: false,
                detailsId: updatePayload
            }
        case SHIPPING_PLAN_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                loading: false,
                isShippingPlan: true
            }
        case NAVIGATE_SHIPPING_PLAN_DETAILS:
            return {
                ...state,
                isShippingPlan: true,
                shippingPlanSelectedValue: updatePayload.shippingPlanSelectedValue
            };
        case SHIPPING_PLAN_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldShipmentNumber: '',
                    dispatchDate: new Date(),
                    fldAppointmentDate: new Date(),
                    fldPickupShipmentDate: selected,
                    fldTotalQuantity: '',
                    fldTotalNoofBox: '',
                    fldDeliveryLocation: '',
                    fldRemarks: ''
                },
                loading: false,
            }

        case CREATE_SHIPPING_PLAN_STYLE_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            }

        case UPDATE_SHIPPING_PLAN_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case NAVIGATE_SHIPPING_PLAN:
            return {
                ...state,
                isShippingPlan: false
            };

        case CREATE_USER_FORM_SHIPPING_PLAN:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }

            }

        case CREATE_SHIPPING_PLAN_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                shippingPlanGet: updatePayload

            }

        case CREATE_SHIPPING_PLAN_GET_FAILURE:
        case UPDATE_SHIPPING_PLAN_GET_FAILURE:
        case DELETE_SHIPPING_PLAN_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            }

        default:
            return state;
    }
};